import { render, staticRenderFns } from "./UserGuide.vue?vue&type=template&id=2004c9b5&scoped=true"
import script from "./UserGuide.vue?vue&type=script&lang=js"
export * from "./UserGuide.vue?vue&type=script&lang=js"
import style0 from "./UserGuide.vue?vue&type=style&index=0&id=2004c9b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2004c9b5",
  null
  
)

export default component.exports